<template>
  <div class="enterprise_visit_content_block clearfix">
    <div class="content_area">
      <div class="content_title">
        {{ company }}
      </div>
      <div class="date_block clearfix">
        <div class="date clearfix">
          <div class="title">
            日期
          </div>
          <div class="text">
            {{ startTime || new Date() | moment("YYYY/MM/DD") }}
          </div>
        </div>
        <div class="time clearfix">
          <div class="title">
            時間
          </div>
          <div class="text">
            {{ startTime || new Date() | moment("HH:mm") }}
          </div>
        </div>
		<div v-if="showStatus" class="registration_status clearfix">
		  <div class="title">
			活動狀態
		  </div>
		  <div class="text" :class="{full: studentsCount >= taker}">
			<span>{{ studentsCount }}/{{ taker }}</span>(已報名/總名額)
		  </div>
		</div>
      </div>
    </div>
    <div class="detail_area">
      <router-link
        :to="`/enterprise-visits/${enterpriseVisitId}`"
        class="detail_bt"
      >
        活動詳情
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EnterpriseVisitCard',
  props: {
    enterpriseVisitId: {
      type: Number,
      required: true
    },
    company: {
      type: String,
      required: true
    },
    startTime: {
      type: String,
      required: true
    },
    showStatus: {
      type: Number,
      required: true
    },
    studentsCount: {
      type: Number,
      required: true
    },
    taker: {
      type: Number,
      required: true
    }
  }
}
</script>
